import React from 'react'
import { observer } from 'mobx-react-lite'
import { RatingSurveyQuestion } from 'posthog-js'

import Stack from '@mui/material/Stack'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import { useTheme } from '@mui/material/styles'

import { Text } from '@mxenabled/mxui'

import { useAnalyticsStore } from '../../common/context/hooks'
import { useGlobalCopyStore } from '../../common/context/hooks'

const RatingScale = () => {
  const { question, response, setResponse } = useAnalyticsStore()
  const { analytics: copy } = useGlobalCopyStore()
  const theme = useTheme()
  const ratingQuestion = question as RatingSurveyQuestion

  const handleSelect = (_: React.MouseEvent<HTMLElement>, response: number | null) => {
    setResponse(response)
  }

  return (
    <React.Fragment>
      <ToggleButtonGroup
        exclusive={true}
        onChange={handleSelect}
        sx={{
          display: 'flex',
          height: 44,
          justifyContent: 'space-between',
          width: '100%',
        }}
        value={response}
      >
        {Array.from({ length: ratingQuestion.scale }, (_, index) => (
          <ToggleButton
            color="primary"
            key={index + 1}
            sx={{ fontWeight: 'bold', width: `${100 / ratingQuestion.scale}%` }}
            value={index + 1}
          >
            {index + 1}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      <Stack
        sx={{
          color: theme.palette.secondary.light,
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <Text bold={true} color="text.secondary" variant="caption">
          {copy.strongly_disagree}
        </Text>
        <Text bold={true} color="text.secondary" variant="caption">
          {copy.strongly_agree}
        </Text>
      </Stack>
    </React.Fragment>
  )
}

export default observer(RatingScale)
